<template>
  <div
    id="delivery-tooltip"
    class="delivery-info cursor-pointer"
    tabindex="0"
    @click="hoverIcon = true"
    @blur="hoverIcon = false"
  >
    <h2
      class="delivery-info__type"
      :class="{
        'delivery-info__type_dark': deliveryType === 'Delivery'
      }"
    >
      {{ deliveryType }}
    </h2>
    <div class="delivery-info__details">
      <b-tooltip
        :target="'delivery-tooltip'"
        custom-class="delivery-info__tooltip"
        triggers="click blur"
        placement="bottom"
      >
        <div v-if="delivery === 'physical'" class="delivery-info__description">
          <p class="mb-1 mt-0">
            Your books are ‘printed to order’ just for you! This ensures the
            author receives a higher revenue for their publication. Not only are
            you supporting the creator, but you are helping to save the planet
            too as this method of production eliminates holding unnecessary
            stock!
          </p>
          <p class="mb-2 mt-1">
            <span class="delivery-info__description-text_bold"
              >Thank you so much for supporting this!</span
            >
          </p>
        </div>

        <hr v-if="isMixedOrder" />

        <div
          v-if="delivery === 'digital' || isMixedOrder"
          class="delivery-info__description"
        >
          <p class="mb-1 mt-0">
            Please allow up to 2 hours for your email containing your digital
            download link to arrive in your inbox. Please ensure you provide us
            with your correct email address when checking out.
          </p>
          <p class="mt-1 mb-0">
            <span class="delivery-info__description-text_bold"
              >Please also check your junk folder for the email.</span
            >
          </p>
        </div>
      </b-tooltip>
      <span
        v-if="delivery !== 'digital'"
        class="delivery-info__short-description mr-2"
        >{{ regionDeliveryLimit }}</span
      >
      <span
        v-if="delivery === 'digital'"
        class="delivery-info__short-description mr-2"
        :class="{
          'delivery-info__short-description_small': delivery === 'digital'
        }"
        >Download emailed within 2&nbsp;hours</span
      >

      <img class="delivery-info__info-icon cursor-pointer" :src="iconSrc" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryInfo',

  props: {
    delivery: {
      type: String,
      required: true,
      enum: ['physical', 'digital']
    },
    region: {
      type: String,
      required: true
    },
    shippingPrice: {
      type: Number,
      default: 0
    },
    regionDeliveryLimit: {
      type: String,
      default: ''
    },
    isMixedOrder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hoverIcon: false
    };
  },
  computed: {
    deliveryType() {
      if (this.delivery !== 'physical') {
        return 'Digital Download';
      }

      return this.shippingPrice ? 'Delivery' : 'Free Delivery';
    },
    iconSrc() {
      return this.hoverIcon
        ? require('@/assets/icons/info-active.svg')
        : require('@/assets/icons/info.svg');
    }
  }
};
</script>

<style lang="scss">
.delivery-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  &__type {
    font-size: 24px;
    color: $green-color;
    font-weight: $font-weight-demi-bold;
    text-transform: uppercase;
    margin: 0;
    text-align: right;

    &_dark {
      color: $dark-color;
    }
  }

  &__short-description {
    font-size: 12px;
    color: $grey-color;
    text-align: right;

    &_small {
      @media (max-width: $screen-width-md) {
        line-height: 12px;
      }
    }
  }

  &__description {
    &-text {
      &_bold {
        font-weight: $font-weight-demi-bold;
      }
    }
  }

  &__tooltip {
    @media (max-width: 460px) {
      transform: translate3d(0, 200px, 0px) translateX(-50%) !important;
      left: 50% !important;
      min-width: 350px;
    }

    font-family: 'Poppins-Regular', sans-serif;
    opacity: 1 !important;

    .arrow {
      display: none;
    }

    .tooltip-inner {
      background: $light-grey-color;
      border-radius: 8px;
      font-size: 14px;
      color: $dark-color;
      max-width: 400px;
      padding: 24px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      @media (max-width: $screen-width-md) {
        max-width: 350px;
      }

      p {
        display: block;
        text-align: left;
      }
    }
  }

  &__details {
    display: flex;
    align-items: center;

    &__info-icon {
      font-size: 1.2rem;
      cursor: pointer;
    }
  }
}
</style>
